import useGetFleetId from '../../../../API/hooks/useGetFleetId';
import useGetVideosByAlertId from '../../../../API/hooks/videos/useGetVideosByAlertId';
import S from './VideoPreviewStyles';

type Props = {
  alertId?: string;
  cameraId?: number;
};

const getVideos = (videos: any): any => videos?.reduce((acc: any, curr: any): any => {
  const video = acc[curr.cameraId];
  if (video) {
    if (new Date(video.createdAt) < new Date(curr.createdAt)) {
      return acc;
    }
  }

  acc[curr.cameraId === 1 ? 'out' : 'in'] = {
    _id: curr._id,
    url: curr.url,
    status: curr.status,
    cameraId: curr.cameraId,
    createdAt: curr.createdAt,
  };
  return acc;
}, {});

function VideoPreview({ alertId, cameraId = 1 }: Props): JSX.Element {
  const fleetId = useGetFleetId();
  const { data, isLoading } = useGetVideosByAlertId(alertId as string, fleetId as string);
  const video = data ? getVideos(data)[cameraId === 1 ? 'out' : 'in'] : undefined;
  return (
    <S.Wrapper>
      <div className="spinner-obj">
        <div />
        <div />
        <div />
        <div />
      </div>
      {!isLoading && (
        <video
          src={video?.url}
          autoPlay
          muted
          loop
          style={{ width: '100%', maxWidth: '150px' }}
        />
      )}
    </S.Wrapper>
  );
}

export default VideoPreview;
